import { render, staticRenderFns } from "./PatientCountWidget.vue?vue&type=template&id=75761bd4&"
import script from "./PatientCountWidget.vue?vue&type=script&lang=js&"
export * from "./PatientCountWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports